#import "./RecordingBlobDetails.graphql"
query SegmentRecordingContents($id: ID!, $pitchShift: Float) {
  segmentRecordingContents(id: $id, pitchShift: $pitchShift) {
    ...recordingBlobDetails
  }
}
